import React from 'react';
import { workStatement, reviews } from '../data/landing';
import { contactBlurb } from '../data/contact';

/** Logo and serif statement introducing the testimonials that follow. */
export function SiteIndex() {
  return <section aria-labelledby="index-heading" className="bg-bg px-page pb-8 pt-20 text-fg md:pb-10 md:pt-28" data-id="element-363" data-mp="lhwujsdq5vv3">
      <h2 id="index-heading" className="sr-only" data-id="element-364" data-mp="qf5e9xeiu7yg">
        What our clients say
      </h2>

      <div data-id="element-365" data-mp="3oym29hp1nbmc">
        {/* Two fixed lines on desktop; wraps naturally on tablet and phones */}
        <p data-lines="manual" className="font-serif text-[36px] font-normal leading-[1.08] tracking-[-0.01em] [text-wrap:wrap] md:text-[48px]" data-id="element-366" data-mp="3txgn0p6kna93">
          <span className="lg:block lg:whitespace-nowrap" data-id="element-367" data-mp="6s7g4vgmfvcv">Founders and investors on building </span>
          <span className="lg:block lg:whitespace-nowrap" data-id="element-368" data-mp="1e5sqguvgzjqt">
            {workStatement.map((s, i) => {
            // First line is rendered above; keep only what follows "building "
            const text = i === 0 ? s.text.replace('Founders and investors on building ', '') : s.text;
            return s.strong ? <span key={i} className="text-fg/40" data-id="element-369" data-mp="qcxcwwm8n0xm">
                  {text}
                </span> : <span key={i} data-id="element-370" data-mp="lapw9tqgqwoy">{text}</span>;
          })}
          </span>
        </p>
        <p className="mt-6 max-w-[400px] text-[15px] leading-[1.55] text-fg/50" data-id="element-371" data-mp="hao3yb6mbfmc">{contactBlurb}</p>
        <p className="mt-8 text-[12px] font-medium uppercase tracking-[0.04em] text-fg/60" data-id="element-372" data-mp="cd5soe54oob6">
          Client testimonials <span className="text-fg/40" data-id="element-373" data-mp="7j1m3vzryiam">({String(reviews.length).padStart(2, '0')})</span>
        </p>
      </div>
    </section>;
}